
export class SearchResultModel<T> {
    items: T[] = [];
    count: number = 0;

    constructor(items?: any[], count?: number) {
        if (items) {
            this.items = items;
        }
        if (count) {
            this.count = count;
        }
    }
}
